import { getFloorPlan } from '@api/services/site-walk.service';
import useDataQuery from '@hooks/use-data-query';

interface IFloorPlanListOptions {
    clientId: string;
    projectId: string;
    floorPlanId: string;
}

const useFloorPlanData = (props: IFloorPlanListOptions) => {
    const { clientId, projectId, floorPlanId } = props;

    const floorPlanQuery = useDataQuery(['floor-plan', clientId, projectId, floorPlanId], () =>
        getFloorPlan(clientId, projectId, floorPlanId)
    );

    return {
        floorPlan: floorPlanQuery.data,
        isLoading: floorPlanQuery.isLoading,
        error: floorPlanQuery.error,
    };
};

export default useFloorPlanData;
